import SectionHead from './SectionHead';
import { timeline } from '@/mocks/meihei';

const toneColor: Record<string, string> = {
  '静': 'bg-cream/10 text-cream/70',
  '涨': 'bg-ember-500/90 text-white',
  '热': 'bg-honey-400/90 text-ink',
  '变': 'bg-cream/15 text-honey-300',
  '落': 'bg-cream/10 text-cream/60',
};

export default function TimelineSection() {
  return (
    <section id="mailuo" className="anchor-target bg-ink py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHead
            dark
            eyebrow="事件脉络 · 时间轴"
            title="一个热点从爆到冷，节奏大致是这样"
            desc="把话题拆成五个阶段。对照这个框架，你基本能判断自己正处在吃瓜链条的哪一段，也不容易被带偏节奏。"
          />
          <span className="inline-flex items-center gap-2 whitespace-nowrap text-xs font-medium text-cream/50">
            <i className="ri-time-line text-base text-honey-300" aria-hidden="true"></i>
            传播生命周期参考
          </span>
        </div>

        <div className="relative mt-10 ml-1.5 border-l border-paper/15 pl-6 md:ml-2 md:pl-10">
          {timeline.map((item, i) => (
            <div key={item.phase} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[31px] top-1 grid h-3.5 w-3.5 place-items-center md:-left-[47px]">
                <span className="absolute h-3.5 w-3.5 rounded-full bg-cream/15"></span>
                <span className="absolute h-1.5 w-1.5 rounded-full bg-honey-300"></span>
              </span>

              <div className="flex flex-col gap-3 rounded-xl border border-paper/10 bg-paper/5 p-5 md:flex-row md:items-start md:gap-6">
                <div className="flex items-center gap-3 md:w-48 md:shrink-0 md:flex-col md:items-start">
                  <span className={`eyebrow text-honey-300`}>{item.phase}</span>
                  <h3 className="display text-base font-bold text-paper md:text-lg">{item.label}</h3>
                  <span className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${toneColor[item.tone]}`}>
                    {item.tone === '涨' ? '热度飙升' : item.tone === '热' ? '高位拉锯' : item.tone === '变' ? '版本反转' : item.tone === '落' ? '沉淀回落' : '平静发酵'}
                  </span>
                </div>
                <p className="flex-1 text-[13px] leading-relaxed text-cream/65 md:text-sm">
                  <span className="mr-2 font-display text-xs font-bold text-ember-400">T{i}·</span>
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}